import { render, staticRenderFns } from "./ManifestConfiguration.vue?vue&type=template&id=0cce8839&scoped=true&"
import script from "./ManifestConfiguration.vue?vue&type=script&lang=js&"
export * from "./ManifestConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ManifestConfiguration.vue?vue&type=style&index=0&id=0cce8839&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce8839",
  null
  
)

export default component.exports